/* Faith Label — Kaching Perks Injector v5
 * Adds per-tier perk bullets to the Kaching bundle widget after it hydrates.
 * Bar 1 (1 PIECE)        → no perks
 * Bar 2 (B2G1, popular)  → 3 perks
 * Bar 3 (B3G2, best val) → 3 perks
 *
 * v5 fix: dedup via data-attribute on the bar element itself instead of
 * checking direct children — the UL gets appended into .bar-content
 * (grandchild of bar), so the v4.7 `:scope > .fl-kaching-perks` check
 * never matched and every MutationObserver tick re-injected another UL.
 */
(function () {
  'use strict';
  if (window.__flKachingPerksLoaded) return;
  window.__flKachingPerksLoaded = true;

  var PERKS = {
    0: [],
    1: [
      'FREE handwritten verse card',
      'Free U.S. shipping over $50',
      '30-day easy returns'
    ],
    2: [
      'FREE charm set & velvet pouch',
      'FREE engraved keepsake card',
      'Lifetime tarnish replacement'
    ]
  };

  function inject(bar, idx) {
    if (!bar) return;
    if (bar.dataset.flPerks === '1') return; // already injected on this bar
    var list = PERKS[idx];
    if (!list || !list.length) {
      bar.dataset.flPerks = '1';
      return;
    }
    var ul = document.createElement('ul');
    ul.className = 'fl-kaching-perks';
    for (var i = 0; i < list.length; i++) {
      var li = document.createElement('li');
      li.textContent = list[i];
      ul.appendChild(li);
    }
    var contentArea = bar.querySelector('.kaching-bundles__bar-content') || bar;
    contentArea.appendChild(ul);
    bar.dataset.flPerks = '1';
  }

  function scan() {
    // Use a Set to dedup hosts in case a bar lives inside both a wrapper
    // and the host root selector match
    var roots = new Set();
    document.querySelectorAll('.fl-kaching-host kaching-bundles-block').forEach(function (n) { roots.add(n); });
    if (roots.size === 0) {
      document.querySelectorAll('.fl-kaching-host').forEach(function (n) { roots.add(n); });
    }
    roots.forEach(function (host) {
      var bars = host.querySelectorAll('.kaching-bundles__bar');
      if (!bars.length) return;
      var realBars = [];
      bars.forEach(function (b) {
        if (b.classList.contains('kaching-bundles__bar-main')) return;
        if (b.classList.contains('kaching-bundles__bar-wrapper')) return;
        if (!b.querySelector('.kaching-bundles__bar-content')) return;
        realBars.push(b);
      });
      // De-dup nested bars: drop any bar that's an ancestor of another real bar
      realBars = realBars.filter(function (b) {
        return !realBars.some(function (other) { return other !== b && b.contains(other); });
      });
      realBars.forEach(function (bar, i) {
        inject(bar, i);
      });
    });
  }

  function scrubLaunchCopy() {
    var replacements = {
      'Pentecost': 'Popular',
      'Sanctuary Club VIP': 'Sanctuary Club',
      'MUSTARD SEED PENDANT VIP': 'Mustard Seed Pendant',
      'FAITH BAND RING VIP': 'Faith Band Ring',
      'CROSS PENDANT NECKLACE VIP': 'Cross Pendant Necklace',
      '60-Day Money-Back Guarantee': '30-Day Easy Returns',
      '60-DAY GUARANTEE': '30-DAY RETURNS',
      '100-Day Sanctuary Guarantee': '30-Day Easy Returns',
      '100-day Sanctuary Guarantee': '30-day easy returns',
      'Free U.S. priority shipping': 'Free U.S. shipping over $50',
      'Free U.S. Shipping over $50': 'Free U.S. shipping over $50',
      'Free US shipping over $49': 'Free U.S. shipping over $50',
      'VIP membership': 'monthly membership',
      'for VIP members': 'for Sanctuary Club members'
    };
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      Object.keys(replacements).forEach(function (from) {
        if (text.indexOf(from) !== -1) text = text.split(from).join(replacements[from]);
      });
      text = text.replace(/FREE U\.S\. SHIPPING(?:\s*\$50\+)*/g, 'FREE U.S. SHIPPING $50+');
      node.nodeValue = text;
    }
  }

  function start() {
    scrubLaunchCopy();
    scan();
    var mo = new MutationObserver(function (mutations) {
      var hit = false;
      for (var i = 0; i < mutations.length && !hit; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && (n.matches('.kaching-bundles__bar') || n.matches('kaching-bundles-block'))) { hit = true; break; }
            if (n.querySelector && n.querySelector('.kaching-bundles__bar')) { hit = true; break; }
          }
        }
      }
      if (hit) { scan(); scrubLaunchCopy(); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function(){ scan(); scrubLaunchCopy(); }, 500);
    setTimeout(function(){ scan(); scrubLaunchCopy(); }, 1500);
    setTimeout(function(){ scan(); scrubLaunchCopy(); }, 3000);
    setTimeout(function(){ scan(); scrubLaunchCopy(); }, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
